import React from 'react';
import AppLayout from "@amzn/meridian/app-layout"
import TopNav from 'src/components/app/top-nav/TopNavContainer';
import Footer from 'src/components/app/footer/FooterContainer';
import AppRouter from 'src/routing/AppRouter';
import SideNav from 'src/components/app/side-nav/SideNavContainer';
import { PageChromeProvider } from 'src/components/app/page-chrome/PageChrome';

import './App.scss';

class App extends React.Component {

    public render() {
        return (
            <PageChromeProvider>
                <AppLayout
                    headerComponent={TopNav}
                    footerComponent={Footer}
                    sidebarComponent={SideNav}
                >
                    <TopNav/>
                    <SideNav/>
                    <AppRouter/>
                    <Footer />
                </AppLayout>
            </PageChromeProvider>
        );
    }
}

export default App;

